import { useMutation } from "react-query";
import axios from '../axios';

const useLogin = ({onSuccess, onError}) => {
  const mutation = useMutation(
    async (params) => {
      return await axios.post("/api/auth/login/seller", {
        email: params.email,
        password: params.password,
      }); 
    },
    {
      onSuccess: (res) => onSuccess(res),
      onError: (err) => onError(err)
    }
  )

  return mutation;
}

export default useLogin;